import React, { useEffect, useState } from 'react'
import { localestr } from '../utils'
import icon from '../icons.svg';
import Menu from './menu'

function CheckList({ data, actions, setModal, printer: user_printer, rights }) {

  const [list, setList] = useState(data || [])
  const [sortedList, setSortedList] = useState([...list])
  const [listFilter, setListFilter] = useState('all')

  useEffect(() => {
    if (listFilter === '0') {
      setSortedList(list.filter((i) => Number(i.payType) === Number(0)))
    } else if (listFilter === '1') {
      setSortedList(list.filter((i) => Number(i.payType) === Number(1)))
    } else if (listFilter === '2') {
      setSortedList(list.filter((i) => Number(i.payType) === Number(5)))
    } else {
      setSortedList([...list])
    }
    // eslint-disable-next-line
  }, [listFilter])
  
  const CheckCopy = (obj, scr = false) => {
    const data = { ...obj }
    if (data.table && typeof data.table === 'object') {
      data.hall = data.table.owner
      data.table = data.table.name || ''
    }
    if (data.hall && typeof data.hall === 'object') data.hall = data.hall.name || ''
    const prn = { data, type: 3, print: true }
    let printer = user_printer || null
    if (scr) printer = { id: 999999, name: 'screen', type: 3, marked: 0 }
    prn.data = { ...data, printer }
    //if(scr) prn.data={...data,printer:{id:999999,name:'screen',type:3,marked:0}}
    actions.loaddata('action=addJobs&data=' + JSON.stringify(prn), undefined, () => { })
  }

  const FiscCopy = (obj, scr = false) => {
    //data: {"id":"9","command":"CheckCopy","NumFiscal":"1202542869","screen":true}
    let printer = user_printer || null
    //console.log(user_printer)

    const prn = { "id": obj[0], "command": "CheckCopy", "NumFiscal": obj[1], "screen": scr, printer }
    //const prn={"id":obj[0],"command":"CheckCopy","NumFiscal":obj[1],"screen":scr}
    actions.loaddata('action=rroCommand&data=' + JSON.stringify(prn), undefined, (d) => { })
  }

  const Fiscalize = (obj, scr = false) => {
    let printer = user_printer || null
    if (scr) printer = { name: 'screen', type: 3, id: null }
    const prn = { 'id': obj, printer }
    actions.loaddata('action=fiskalizeOrder&data=' + JSON.stringify(prn), undefined, (d) => { })
  }

  const Unpost = (obj) => {
    actions.loaddata('action=unpostOrder&data=' + obj, undefined, (d) => {
      //console.log(obj);console.log(d);console.log(list);
      if (d.status === 'OK') {
        const new_list = sortedList.filter(el => el.id !== obj)
        setList(new_list)
        setTimeout(actions.updateStatus, 300)
      } else if (d.msg) actions.msg(d.msg)
    })
  }

  const prn_req = (act) => {
    actions.msg(localestr('Куди вивести результат?'), localestr('Запитання'), [{ caption: localestr('Екран'), action: () => act(true) }, { caption: localestr('Принтер'), action: () => act() }, { caption: localestr('Відмінити'), action: () => { } }])
  }

  const unp_req = (act) => {
    //console.log('obj')
    actions.msg(localestr('Ви дійсно хочете відмінити закриття фіскального чека?'), localestr('Запитання'), [{ caption: localestr('Так'), action: () => act() }, { caption: localestr('Ні'), action: () => { } }])
  }

  const tblitems = sortedList.map((el, idx) => {
    let info = el.table.owner.name + ' ' + el.table.name
    if (el.docType && parseInt(el.docType) === 1) info = localestr('Доставка') + ' ' + (el.address || '')
    else if (el.docType && parseInt(el.docType) === 2) info = localestr('Самовивіз') + ' ' + (el.name || '')
    let buttons = [{ id: 'btn1', name: localestr('Копія чека'), icon: '#btn7', action: () => { prn_req((d) => CheckCopy(el, d)) } }]
    let cls = ''
    if (el.fisc_number) {
      let arr = el.fisc_number.split(';')
      for (let i = 0; i < arr.length - 1; i++) {
        let obj = arr[i].split('-')
        buttons.push({ id: 'btn2', name: localestr('Фіскальний чек') + ' ' + obj[1], icon: '#btn7', action: () => { prn_req((d) => FiscCopy(obj, d)) } })
      }
      cls = 'done'
    } else if (el.fiscal === 2) {
      buttons.push({ id: 'btn2', name: localestr('Зробити фіскальним'), icon: '#rro', action: () => { prn_req((d) => Fiscalize(el.id, d)) } })
    }
    if (rights.urUnclose || rights.urAdmin) {
      if (el.fisc_number) {
        buttons.push({ id: 'btn3', name: localestr('Відмінити закриття'), icon: '#btn6', action: () => { unp_req(() => Unpost(el.id)) } })
      } else {
        buttons.push({ id: 'btn3', name: localestr('Відмінити закриття'), icon: '#btn6', action: () => Unpost(el.id) })
      }
    }
    let img = '#btn10'
    if (el.payType && parseInt(el.payType) === 1) img = '#btn9'
    if (el.payType && parseInt(el.payType) === 2) img = '#btn4'
    if (el.payType && parseInt(el.payType) === 3) img = '#rro'
    if (el.payType && parseInt(el.payType) === 4) img = '#cert'
    if (el.payType && parseInt(el.payType) === 6) img = '#btn8'

    return <tr key={idx} className={cls}>
      <td style={{ width: '40px', minWidth: '40px', flexGrow: '0', flexBasis: '0', padding: '1px 4px' }}>{el.id}</td>
      <td style={{ width: '50px', minWidth: '50px', flexGrow: '0', flexBasis: '0', padding: '1px 4px' }}>{(new Date(el.date).toLocaleTimeString().substring(0, 5))}</td>
      <td style={{ width: '100px', minWidth: '100px', flexGrow: '100', flexBasis: '100px', textAlign: 'left', padding: '1px 4px' }}>{info}</td>
      {parseInt(el.payType) === 5 ? (<>
        <td style={{ width: '100px', minWidth: '50px', flexGrow: '20', flexBasis: '50px', textAlign: 'right' }}>
          {el.sum1 && el.sum1} <br /> {el.sum2 && el.sum2} <br /> {el.sum3 && el.sum3} 
        </td>
        <td style={{ width: '32px', minWidth: '32px', flexGrow: '0', flexBasis: '0', padding: '1px 4px' }}>
          {el.sum1 && (<><img style={{ width: '25px', height: '25px', margin: '-4px -4px -2px -4px' }} src={icon + '#btn10'} alt='' /> <br /></>)} 
          {el.sum2 && (<><img style={{ width: '25px', height: '25px', margin: '-4px -4px -2px -4px' }} src={icon + '#btn9'} alt='' /> <br /></>)} 
          {el.sum3 && (<img style={{ width: '25px', height: '25px', margin: '-4px -4px -2px -4px' }} src={icon + '#cert'} alt='' />)} 
        </td>
      </>) : (<>
        <td style={{ width: '100px', minWidth: '50px', flexGrow: '20', flexBasis: '50px', textAlign: 'right' }}>{el.amount}</td>
        <td style={{ width: '32px', minWidth: '32px', flexGrow: '0', flexBasis: '0', padding: '1px 4px' }}><img style={{ width: '30px', height: '30px', margin: '-4px -4px -2px -4px' }} src={icon + img} alt='' /></td>
      </>)
      }
      <td style={{ width: '32px', minWidth: '32px', flexGrow: '0', flexBasis: '0', padding: '1px 4px' }}><Menu bottom={data.length > 5 && data.length - 3 < idx ? true : false} data={buttons}><img style={{ width: '32px', height: '32px', margin: '-4px 0px -2px -4px' }} src={icon + '#btn11'} alt='' /></Menu></td></tr>
  })


  return (
    <div className='modal'><div className='window'>
      <div style={{ flexDirection: 'row', display: 'flex', justifyContent: 'flex-start' }}><div className='caption'>{localestr('Реєстр чеків')}</div><div className='closebtn' onClick={() => { setModal('') }} /></div>
      <div style={{ background: '#ffffff', maxHeight: '90vh', overflow: 'auto' }} className='content'>
        <div style={{ maxHeight: '90vh' }} className={'ord_table'} ><table style={{ minWidth: '345px' }}>
          <div className='tabpanel'>
            <button
              className={`tabbuton ${listFilter === 'all' && 'active'}`}
              onClick={() => setListFilter('all')}
            >
              Усі Чеки
            </button>
            <button
              className={`tabbuton ${listFilter === '0' && 'active'}`}
              onClick={() => setListFilter('0')}
            >
              Готівка
            </button>
            <button
              className={`tabbuton ${listFilter === '1' && 'active'}`}
              onClick={() => setListFilter('1')}
            >
              Карта
            </button>
            <button
              className={`tabbuton ${listFilter === '2' && 'active'}`}
              onClick={() => setListFilter('2')}
            >
              Комбінований
            </button>
          </div>

          <thead><tr>
            <th style={{ width: '40px', minWidth: '40px', flexGrow: '0', flexBasis: '0' }}>№</th>
            <th style={{ width: '50px', minWidth: '50px', flexGrow: '0', flexBasis: '0' }}>{localestr('Час')}</th>
            <th style={{ width: '100px', minWidth: '100px', flexGrow: '100', flexBasis: '100px', textAlign: 'center' }}>{localestr('Зміст')}</th>
            <th style={{ width: '100px', minWidth: '50px', flexGrow: '20', flexBasis: '50px', textAlign: 'center' }}>{localestr('Сума')}&nbsp;</th><th style={{ width: '32px', minWidth: '32px', flexGrow: '0', flexBasis: '0', padding: '1px 4px' }}></th>
            <th style={{ width: '32px', minWidth: '32px', flexGrow: '0', flexBasis: '0', padding: '1px 4px' }}>...</th></tr></thead><tbody style={{ minHeight: '155px' }}>
            {tblitems}
          </tbody></table>
        </div>

      </div>
    </div></div>
  )
}

export default CheckList